"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NolMemberInfoSchema = void 0;
var zod_1 = __importDefault(require("zod"));
exports.NolMemberInfoSchema = zod_1.default.object({
    name: zod_1.default.string(),
    phone: zod_1.default.string(),
    email: zod_1.default.string(),
});
